// extracted by mini-css-extract-plugin
module.exports = {"package":"Package_package__s0KUm","package--editorial":"Package_package--editorial__iI_Qz","web":"Package_web__0N10N"};